if ( typeof VideoPopup !== 'function' ) {

  class VideoPopup extends HTMLElement {

    constructor(){
      
      super();

      if (window.location.pathname === '/' && this.id.endsWith('__video_t4KpEg')) {
        const trigger = this.querySelector('[data-js-video-popup-link]');
        const close = this.querySelector('[data-js-video-popup-close]');
        const container = this.querySelector('[data-js-video-popup-container]');
        const template = this.querySelector('template');
        if (trigger && close && container && template) {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-expanded', 'false');
          const playIcon = trigger.querySelector('.video-popup__play');
          trigger.addEventListener('focus', () => {
            if (playIcon) { playIcon.style.outline = '3px solid currentColor'; playIcon.style.outlineOffset = '4px'; }
          });
          trigger.addEventListener('blur', () => {
            if (playIcon) { playIcon.style.outline = ''; playIcon.style.outlineOffset = ''; }
          });
          const hideVideo = () => {
            if (!this.classList.contains('video-opened')) return;
            this.querySelectorAll('iframe, video, .video-popup__blackout').forEach(element => element.remove());
            this.classList.remove('video-opened');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.removeAttribute('tabindex');
            trigger.focus({preventScroll: true});
          };
          trigger.addEventListener('click', event => {
            event.preventDefault();
            if (this.classList.contains('video-opened')) return;
            const blackout = document.createElement('div');
            blackout.className = 'video-popup__blackout';
            blackout.style.opacity = '1';
            this.append(blackout);
            const media = template.content.firstElementChild.cloneNode(true);
            container.append(media);
            this.classList.add('video-opened');
            trigger.setAttribute('aria-expanded', 'true');
            trigger.setAttribute('tabindex', '-1');
            close.focus({preventScroll: true});
            if (media.tagName === 'VIDEO') {
              media.tabIndex = 0;
              const playback = media.play();
              if (playback) playback.catch(() => {});
            }
          });
          trigger.addEventListener('keydown', event => {
            if (event.key === ' ') { event.preventDefault(); trigger.click(); }
          });
          close.addEventListener('click', hideVideo);
          this.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.classList.contains('video-opened')) {
              event.preventDefault();
              hideVideo();
            }
          }, true);
          return;
        }
      }


      this.querySelector('[data-js-video-popup-link]').addEventListener('click',e=>{

        e.preventDefault();

        const blackout = document.createElement('div');
        blackout.classList.add('video-popup__blackout');
        this.append(blackout);
        setTimeout(()=>{
          blackout.style.opacity = '1';
        },10)

        this.classList.add('video-opened');

        if ( this.querySelector('[data-js-video-popup-close]') ) {
          this.querySelector('[data-js-video-popup-close]').addEventListener('click', e=>{
            this.querySelectorAll('iframe, video').forEach(elm=>{elm.remove()});
            blackout.remove();
            this.classList.remove('video-opened');
          })
        }

        setTimeout(()=>{
          this.querySelector('[data-js-video-popup-container]').appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
          setTimeout(()=>{
            this._playMedia(this.closest('[data-video]'));
          }, 500);
        },50);

      });

    }

    _playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

  }

  if ( typeof customElements.get('video-popup') == 'undefined' ) {
    customElements.define('video-popup', VideoPopup);
  }

}